import React from 'react';
import { getImage } from 'gatsby-plugin-image';

// ** Components
import { PagePreview } from 'components';

// ** Hooks
import { usePartnersData } from 'data/hooks/partners/use-partners-data';

export const PreviewSection = () => {
  const { previewSection } = usePartnersData();
  const banner = getImage(previewSection.previewImage);
  return (
    <PagePreview
      title={previewSection.previewTitle}
      invertLogoColor={true}
      imageProps={{
        image: banner,
        alt: 'productsBanner',
      }}
    />
  );
};
